import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { CurrencyPipe } from '@angular/common'

@Component({
  selector: 'app-price',
  templateUrl: './price.component.html',
  imports: [
    CurrencyPipe,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './price.component.sass',
})
export class PriceComponent {
  @Input() amount!: number
}
